module.exports = __webpack_public_path__ + "img/finance_black_icon.312b4269.svg";